<div>
  <!-- Top Section: Three Cards -->
  <nb-card *ngIf="!isProduction">
    <nb-card-header i18n>
      Effortlessly create tailored campaigns with only the essential fields visible and pre-filled for a streamlined
      experience.
    </nb-card-header>
    <nb-card-body>
      <div class="top-section">
        <nb-card (click)="openModal('so')">
          <nb-card-header i18n><nb-icon icon="gift-outline"></nb-icon>Special Offer</nb-card-header>
          <nb-card-body i18n>Start building your Special Offer Campaign</nb-card-body>
          <nb-card-footer>
            <div class="badges">
              <button class="green" i18n>Prime</button>
              <button class="blue" i18n>Legacy</button>
            </div>
            <div class="message-card">
              <span i18n>Start</span>
              <nb-icon icon="arrow-forward-outline"></nb-icon>
            </div>
          </nb-card-footer>
        </nb-card>
        <!-- <nb-card (click)="openModal('bn')">
          <nb-card-header><nb-icon icon="image-outline"></nb-icon>Banner</nb-card-header>
          <nb-card-body>Start building your Banner Campaign</nb-card-body>
          <nb-card-footer>
            <div class="badges">
              <button class="green">Prime</button>
              <button class="blue">Legacy</button>
            </div>
            <div class="message-card">
              <span>Start</span>
              <nb-icon icon="arrow-forward-outline"></nb-icon>
            </div>
          </nb-card-footer>
        </nb-card> -->
        <nb-card (click)="openModal('mc')">
          <nb-card-header i18n><nb-icon icon="message-square-outline"></nb-icon>Message Center</nb-card-header>
          <nb-card-body i18n>Start building your Message Center Campaign</nb-card-body>
          <nb-card-footer>
            <div class="badges">
              <button class="blue" i18n>Legacy</button>
            </div>
            <div class="message-card">
              <span i18n>Start</span>
              <nb-icon icon="arrow-forward-outline"></nb-icon>
            </div>
          </nb-card-footer>
        </nb-card>
        <nb-card (click)="openModal('ct')">
          <nb-card-header i18n><nb-icon icon="monitor-outline"></nb-icon>Contextual Message</nb-card-header>
          <nb-card-body i18n>Start building your Contextual Message Campaign</nb-card-body>
          <nb-card-footer>
            <div class="badges">
              <button class="green" i18n>Prime</button>
              <button class="blue" i18n>Legacy</button>
            </div>
            <div class="message-card">
              <span i18n>Start</span>
              <nb-icon icon="arrow-forward-outline"></nb-icon>
            </div>
          </nb-card-footer>
        </nb-card>
      </div>
    </nb-card-body>
  </nb-card>

  <nb-card *ngIf="!isTest">
    <nb-card-header i18n>
      My Campaigns Deliveries
      <nb-icon
        class="ml-2"
        icon="info-outline"
        nbTooltip="Monitor deliveries in the last 14 days for campaigns that you created and favorited."
        i18n-nbTooltip
      ></nb-icon
    ></nb-card-header>
    <nb-card-body>
      <app-line-graph
        [graphData]="graphData"
        (reload)="reloadDeliveries()"
        [height]="420"
        [maxVisibleLines]="8"
      ></app-line-graph>
    </nb-card-body>
  </nb-card>

  <!-- Bottom Section: Additional content -->
  <div class="bottom-section">
    <app-ngx-mat-table
      tableName="My Campaigns"
      description="Monitor campaigns that you created and favorited."
      dataType="my_campaign"
      sortActive="last_updated_dttm"
      sortDirection="desc"
      [tableData]="tableData"
      (clickedButton)="clickedButton($event)"
      i18n-tableName
      i18n-description
    ></app-ngx-mat-table>
  </div>
</div>
